// Interface for the API response structure
interface SpecificationItem {
  name: string;
  description: string;
  value: string;
}

interface CategorySpecifications {
  included: SpecificationItem[];
  notIncluded: SpecificationItem[];
}

interface VariantSpecifications {
  [category: string]: CategorySpecifications;
}

interface VariantData {
  variantId: string;
  variantName: string;
  specifications: VariantSpecifications;
}

export interface VariantComparisonResponse {
  previous: VariantData | null;
  current: VariantData;
  next: VariantData | null;
}

// Service function to fetch variant specifications
export const fetchVariantSpecifications = async (
  variantSlug: string
): Promise<VariantComparisonResponse | null> => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE}/features/comparisons/${variantSlug}/next`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: VariantComparisonResponse = await response.json();
    return data;
  } catch (error: any) {
    console.error("Error fetching variant specifications:", error.message);
    return null;
  }
};

export type {
  VariantData,
  VariantSpecifications,
  CategorySpecifications,
  SpecificationItem,
};
